import React, { useState } from 'react';
import Login from './Login';
import { isLoggedIn } from '../../../auth';
import { AuthProvider } from '../../../context/AuthContext';

interface AuthGateProps {
  children: React.ReactNode;
}

const AuthGate: React.FC<AuthGateProps> = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());

  if (!loggedIn) {
    return <Login onLogin={() => setLoggedIn(true)} />;
  }
  return <AuthProvider>{children}</AuthProvider>;
};

export default AuthGate;
